<template>
  <div>
    <el-form inline>
      <el-row inline>
        <el-col :span="24">
          <el-form-item label="日志名称">
            <el-select v-model="logName" @change="logHandle">
              <el-option v-for="(logPath, logPahtIndex) in logPathes" :value="logPath.path" :label="logPath.name"
                :key="'logPath' + logPahtIndex"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="日志路径">
            <el-button v-if="logPath" @click="selectLog('log')" :type="clickLogType == 'log' ? 'primary' : ''">
              {{ logPath }}
            </el-button>
            <!-- <el-button v-if="logPath && btnInList('log_management','monitor_log_delete')" -->
            <el-button v-if="logPath && btnInList('instance_log', 'instance_log_delete')" size="mini" type="primary"
              @click="clearLogsConfirm">清除日志
            </el-button>
            <!--            <el-button v-if="logPath" type="primary" @click="clearLogs" size="mini">清除日志</el-button>-->
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备份路径">
            <el-button v-if="backupPath" @click="selectLog('backup')" :type="clickLogType == 'backup' ? 'primary' : ''">
              {{ backupPath }}
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="line"></div>
    <el-row style="margin-bottom: 2%; margin-top: 2%;">
      <el-col :span="6" :offset="1" style="font-size: 16px">
        总数: {{ logSummary.total }}
      </el-col>
      <el-col :span="6" style="font-size: 16px">
        起始时间: {{ new Date(logSummary.startTime).Format('yyyy/MM/dd hh:mm:ss') }}
      </el-col>
      <el-col :span="6" style="font-size: 16px">
        结束时间: {{ new Date(logSummary.endTime).Format('yyyy/MM/dd hh:mm:ss') }}
      </el-col>
    </el-row>
    <div class="line"></div>
    <el-form inline style="margin-top: 2%;">
      <el-row>
        <el-col :span="8">
          <el-form-item label="起始时间">
            <el-date-picker v-model="startTime" type="datetime" placeholder="请选择开始时间"
              :picker-options="pickerOptions"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="结束时间">
            <el-date-picker v-model="endTime" type="datetime" placeholder="请选择结束时间"
              :picker-options="pickerOptions"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4" :offset="2">
          <el-button @click="downLoad" v-if="btnInList('instance_log', 'instance_log_cat')"
                     type="primary" size="mini" style="margin-top: 4%">
            下载
          </el-button>
          <el-button @click="back" v-if="dataList.length > 1" type="primary" size="mini" style="margin-top: 4%">
            返回
          </el-button>
        </el-col>
      </el-row>
    </el-form>
    <div class="line"></div>

    <el-table :data="tableData" @selection-change="handleSelectionChange" :row-key="rowKey">
      <el-table-column type="selection" width="55" reserve-selection></el-table-column>
      <el-table-column align="center" label="文件名称" prop="name"></el-table-column>
      <el-table-column align="center" label="文件大小" prop="size"></el-table-column>
      <el-table-column align="center" label="创建时间" width="220">
        <template v-slot="{ row }">
          {{ new Date(row.creationTime).Format('yyyy/MM/dd hh:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="最后修改时间" width="220">
        <template v-slot="{ row }">
          {{ new Date(row.lastModifiedTime).Format('yyyy/MM/dd hh:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="120">
        <template v-slot="{ row }">
          <div v-if="row.isDir == false">
            <div v-if="matchType(row.name) == '解压' && btnInList('instance_log', 'instance_log_unzip')">
              <el-button type="warning" size="mini" style="width: 75px" @click="unZip(row.name)">
                解压
              </el-button>
            </div>
            <div v-else>
              <el-dropdown v-if="row.isDir == false && btnInList('instance_log', 'instance_log_cat')" @command="catLog">
                <el-button type="primary" size="mini">
                  {{ matchType(row.name) }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    :command="{ name: row.name, charset: 'UTF-8', size: row.size }">UTF-8</el-dropdown-item>
                  <el-dropdown-item :command="{ name: row.name, charset: 'GB2312', size: row.size }">GB2312
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <span v-else>
            <el-button type="success" size="mini" style="width: 75px"
                       @click="enterDir(row.name, true)">进入</el-button>
          </span>

        </template>
      </el-table-column>
    </el-table>

    <el-pagination class="fy" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="currentPage" :page-sizes="[20, 50, 100]" :page-size="pageSize" :total="logSummary.total"
      layout="total, sizes, prev, pager, next, jumper"></el-pagination>


    <el-dialog :title="fileName" :visible.sync="logContentDialogVisible" width="80%" center append-to-body>
      <pre style="white-space: pre-wrap;">{{ logContent }}</pre>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="logContentDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import { mapState } from "vuex";

export default {
  name: "ConfigList",
  props: {
    instanceId: {
      type: Number
    },
    serviceId: {
      type: Number
    },
    moduleType: {
      type: String
    },
    moduleVersion: {
      type: String
    },
    deviceId: {
      type: [Number, String]
    }
  },
  data() {
    return {
      dataList: [],
      buttonName: "",
      logPathes: [],
      logName: '',
      logPath: '',
      startTime: null,
      endTime: null,
      timeRange: [],
      logSummary: {
        total: null,
        startTime: null,
        endTime: null,
        logFileInfoDtoList: [],
      },
      logContentDialogVisible: false,
      fileName: "",
      logContent: "",
      configs: [], //上传文件信息列表
      currentXml: {},

      //分页
      pageSize: 20,
      currentPage: 1,
      multipleSelection: [],

      pickerOptions: {
        disabledDate: (time) => {
          const temp = time.getTime();
          const stime = this.logSummary.startTime;
          const etime = this.logSummary.endTime;
          return temp < stime - 8.64e7 || temp > etime
        }
      },
      clickLogType: '',
      flagPath: '',
      downPath: '',
      defaultPath: '',
      backupPath: '', //备份路径
    }
  },
  computed: {
    ...mapState(['currentMenu', 'listOperations', 'currentMenuOperations']),
    tableData() {
      let arr = [];
      let start = (this.currentPage - 1) * this.pageSize
      let end = this.currentPage * this.pageSize
      let dataByLimit = []
      if (this.logSummary.logFileInfoDtoList) {
        if (this.startTime && this.endTime) {
          dataByLimit = this.logSummary.logFileInfoDtoList.filter(log => log.lastModifiedTime >= this.startTime && log.lastModifiedTime <= this.endTime)
          arr = dataByLimit.slice(start, end)
        } else {
          arr = this.logSummary.logFileInfoDtoList.slice(start, end)
        }
      }
      return arr
    },
    // 操作按钮是否可以显示
    btnInList() {
      return (name, childName) => {
        let btn = this.listOperations.filter(op => op.name.includes(name));
        if (!childName) {
          return btn.length > 0
        } else {
          return btn[0].buttonList.some(childOp => childOp.name.includes(childName))
        }

      }
    },
  },
  watch: {
    serviceId: {
      handler(newVal, oldVal) {
        this.getLogPath();
      },
      deep: true
    }
  },
  created() {
    this.getLogPath();
  },

  methods: {
    clearLogsConfirm() {
      this.$confirm('您确认要清除日志吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.clearLogs()
      }).catch(() => {

      });
    },
    back() {
      if (this.dataList.length > 1) {
        this.dataList.pop();
        this.enterDir(this.dataList.pop(), false)
      } else {
        this.dataList = [];
        this.dataList.push("");
        this.selectLog()
      }
    },
    rowKey(row) {
      return row.name
    },
    getLogPath() {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      let url = this.baseUrl3 + "log/findLogPathByServiceId/" + this.serviceId;
      this.$axios
        .get(url)
        .then(({ data: { msg, data, code } }) => {
          if (code == 20000) {
            this.logPathes = data;
          } else {
            this.$message({ showClose: true, message: msg, type: "error" });
            console.log(msg);
          }
          loading.close();
        })
        .catch(err => {
          loading.close();
          console.log(err);

        });
    },
    // 选择日志名称
    logHandle(value) {
      // 路径实体
      let item = this.logPathes.filter(log => log.path == value)[0];
      this.logPath = item.path;
      this.backupPath = item.backupPath;
      this.clickLogType = ''
    },
    matchType(name) {
      let flieArr = name.substring(name.lastIndexOf('.') + 1);
      let buttonName = "";
      if (flieArr == "rar") {
        buttonName = "解压";
      } else if (flieArr == "zip") {
        buttonName = "解压";
      } else if (flieArr == "gz") {
        buttonName = "解压";
      } else if (flieArr == "txt") {
        buttonName = "查看";
      } else if (flieArr == "log") {
        buttonName = "查看";
      } else {
        buttonName = "查看";
      }
      return buttonName
    },
    unZip(name) {
      let param = "";
      //this.dataList.push(name);
      this.dataList.forEach((d) => {
        if (d) {
          param = param + '/' + d
        }
      });
      param = param + '/' + name;
      let path;
      if (this.flagPath) {
        path = this.flagPath + param;
      } else {
        path = this.logPath + param;
      }
      // let path = this.logPath + param;
      // let url = this.baseUrl + "log/deCompressLog/" + this.instanceId + '/' + encodeURIComponent(encodeURIComponent(path));
      let url = this.baseUrl3 + "log/deCompressLog"
      let data = {
        instanceId:this.instanceId,
        path: path
      }

      this.$axios
        .post(url,data)
        .then(({ data: { msg, data, code } }) => {
          if (code == 20000) {
            this.refreshDir()
          } else {
            this.$message({ showClose: true, message: msg, type: "error" });
            console.log(msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    enterDir(name) {
      this.downPath = "";
      this.defaultPath = "";
      let param = "";
      this.dataList.push(name);
      this.dataList.forEach(d => {
        if (d != "") {
          param += "/"+d
        }
      });
      let path;
      if (this.flagPath) {
        path = this.flagPath + param;
        this.downPath = path;
      } else {
        path = this.logPath + param;
        this.defaultPath = path;
      }
      // let path = this.logPath + param
      // let url = this.baseUrl + "log/getLogSummary/" + this.instanceId + '/' + encodeURIComponent(encodeURIComponent(path));
      let url = this.baseUrl3 + "log/getLogSummary"
      let data = {
        instanceId: this.instanceId,
        path: path
      };

      this.$axios.post(url, data)
        .then(({ data: { msg, data, code } }) => {
          if (code == 20000) {
            this.currentPage = 1;
            this.logSummary = data;
            this.setDownloadTime(data);
          } else {
            this.$message({ showClose: true, message: msg, type: "error" });
            console.log(msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    refreshDir() {
      let param = "";
      this.dataList.forEach(d => {
        if (d != "") {
          param += "/"+d
        }
      });
      let path;
      if (this.flagPath) {
        path = this.flagPath + param;
      } else {
        path = this.logPath + param;
      }
      // let path = this.logPath + param
      // let url = this.baseUrl + "log/getLogSummary/" + this.instanceId + '/' + encodeURIComponent(encodeURIComponent(path));
      let url = this.baseUrl3 + "log/getLogSummary"
      let data = {
        instanceId: this.instanceId,
        path: path
      };

      this.$axios.post(url, data)
        .then(({ data: { msg, data, code } }) => {
          if (code == 20000) {
            this.logSummary = data;
            this.setDownloadTime(data);
          } else {
            this.$message({ showClose: true, message: msg, type: "error" });
            console.log(msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    selectLog(type) {
      this.flagPath = "";
      this.dataList = [];
      this.dataList.push("");
      // this.logPath = value;
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      // let path = encodeURIComponent(value);
      let path = null;
      this.clickLogType = type;
      if (type == 'backup') {
        if (this.moduleType == 'service_agent') {
          path = this.backupPath;
          this.flagPath = path;
        } else {
          path = this.backupPath + '/' + this.instanceId + '/' + this.moduleType + '_' + this.moduleVersion
          this.flagPath = path;
        }
      } else {
        path = this.logPath
      }
      console.log(path);
      // let url = this.baseUrl + "log/getLogSummary/" + this.instanceId + "/" + encodeURIComponent(encodeURIComponent(path));
      let url = this.baseUrl3 + "log/getLogSummary"
      let data = {
        instanceId: this.instanceId,
        path: path
      };

      this.$axios.post(url, data)
        .then(({ data: { msg, data, code } }) => {
          if (code == 20000) {
            data.logFileInfoDtoList = data.logFileInfoDtoList ? data.logFileInfoDtoList : []
            if (data.logFileInfoDtoList) {
              for (let i = 0; i < data.logFileInfoDtoList.length; i++) {
                this.name = data.logFileInfoDtoList[i].name
              }
            }
            this.logSummary = data;
            this.setDownloadTime(data);
          } else {
            this.$message({ showClose: true, message: msg, type: "error" });
            console.log(msg);
          }
          loading.close();
        })
        .catch(err => {
          loading.close();
          console.log(err);
        });
    },
    setDownloadTime(data) {
      this.timeRange = [new Date(this.logSummary.startTime), new Date(this.logSummary.endTime)];
      this.startTime = new Date(this.logSummary.startTime);
      this.endTime = new Date(this.logSummary.endTime);
      this.selfTime = [this.startTime, this.endTime]
    },
    catLog(command) {
      if (command.size > 10 * 1024 * 1024) {
        this.$confirm('当前文件过大，不可查看，仅支持下载，是否下载?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.bigDownLoad(command.name)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      } else {
        let loading = Loading.service({
          fullscreen: true,
          text: "数据加载中..."
        });
        let param = "";
        this.dataList.forEach(d => {
          param = param + '/' + d + '/'
        });


        let path;
        if (this.flagPath) {
          path = this.flagPath + param
        } else {
          path = this.logPath + param
        }
        // let path = encodeURIComponent(this.logPath + param);
        // let url = this.baseUrl + "log/catLog/" + this.instanceId + "/" + path + "/" + command.name + "/" + command.charset;
        let url = this.baseUrl3 + "log/catLog"
        let data = {
          instanceId: this.instanceId,
          path: path,
          name: command.name,
          charset: command.charset
        };
        this.$axios.post(url, data)
          .then(({ data: { msg, data, code } }) => {
            if (code == 20000) {
              console.log("data: " + data);
              this.logContentDialogVisible = true;
              this.logContent = data;
            } else {
              this.$message({ showClose: true, message: msg, type: "error" });
              console.log(msg);
            }
            loading.close();
          })
          .catch(err => {
            loading.close();
            console.log(err);
          });
      }

    },
    bigDownLoad(bigFileName) {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      let that = this;
      let logFileNameStr = bigFileName;


      // let path = encodeURIComponent(this.logPath);
      let path;

      if (this.clickLogType == 'backup') {
        if (this.moduleType == 'service_agent') {
          if (this.downPath) {
            path = this.downPath
          } else {
            path = this.backupPath
          }
        } else {
          if (this.downPath) {
            path = this.downPath
          } else {
            path = this.backupPath + '/' + this.instanceId + '/' + this.moduleType + '_' + this.moduleVersion
          }
        }
      } else {
        if (this.defaultPath) {
          path = this.defaultPath;
        } else {
          path = this.logPath
        }
      }
      // let url = this.baseUrl + "log/getDownloadUrl/" + this.instanceId + "/" + encodeURIComponent(encodeURIComponent(path))
      //   + "/" + this.startTime.getTime() + "/" + this.endTime.getTime() + "/" + logFileNameStr;
      let url = this.baseUrl3 + "log/download"
      let data = {
        instanceId: this.instanceId,
        path: path,
        startTime: this.startTime.getTime(),
        endTime: this.endTime.getTime(),
        fileNames: logFileNameStr,
      };

      this.$axios.post(url, data, {
        responseType: 'blob' // 设置响应类型为blob
      })
        .then(function (response) {
          // 创建一个Blob对象
          const blob = new Blob([response.data], { type: "application/zip" }); // 根据文件类型设置MIME类型
          // 创建一个下载链接
          const url = window.URL.createObjectURL(blob);
          // 创建一个a标签并设置属性以开始下载
          const a = document.createElement('a');
          a.href = url;
          // content-disposition必须为小写
          const contentDisposition = response.headers['content-disposition'];
          let filename = 'default_filename.zip'; // 默认文件名
          if (contentDisposition) {

            const matches = /filename="(.+)"/.exec(contentDisposition);
            if (matches.length > 1) {
              filename = matches[1];
            }
          }
          a.download = filename; // 设置下载文件的名称
          // 将a标签添加到DOM中并模拟点击以开始下载
          document.body.appendChild(a);
          a.click();
          // 清理DOM
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
          loading.close();
        })
        .catch(function (error) {
          loading.close();
          console.log(error); // 处理错误情况
        });
    },
    downLoad() {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      let that = this;

      let logFileNameStr = that.generateLogFileStr();
      // let path = encodeURIComponent(this.logPath);
      let path;

      if (this.clickLogType == 'backup') {
        if (this.moduleType == 'service_agent') {
          if (this.downPath) {
            path = this.downPath
          } else {
            path = this.backupPath
          }
        } else {
          if (this.downPath) {
            path = this.downPath
          } else {
            path = this.backupPath + '/' + this.instanceId + '/' + this.moduleType + '_' + this.moduleVersion
          }
        }
      } else {
        if (this.defaultPath) {
          path = this.defaultPath;
        } else {
          path = this.logPath
        }
      }

      // let url = this.baseUrl + "log/getDownloadUrl/" + this.instanceId + "/" + encodeURIComponent(encodeURIComponent(path))
      //   + "/" + this.startTime.getTime() + "/" + this.endTime.getTime() + "/" + logFileNameStr;
      let url = this.baseUrl3 + "log/download"
      let data = {
        instanceId: this.instanceId,
        path: path,
        startTime: this.startTime.getTime(),
        endTime: this.endTime.getTime(),
        fileNames: logFileNameStr,
      };

      this.$axios.post(url, data, {
        responseType: 'blob' // 设置响应类型为blob
      })
      .then(function (response) {
          // 创建一个Blob对象
          const blob = new Blob([response.data], { type: "application/zip" }); // 根据文件类型设置MIME类型
          // 创建一个下载链接
          const url = window.URL.createObjectURL(blob);
          // 创建一个a标签并设置属性以开始下载
          const a = document.createElement('a');
          a.href = url;

          const contentDisposition = response.headers['content-disposition'];
          let filename = 'default_filename.zip'; // 默认文件名
          if (contentDisposition) {
            const matches = /filename="(.+)"/.exec(contentDisposition);
            if (matches.length > 1) {
              filename = matches[1];
            }
          }
          a.download = filename; // 设置下载文件的名称
          // 将a标签添加到DOM中并模拟点击以开始下载
          document.body.appendChild(a);
          a.click();
          // 清理DOM
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
          loading.close();
        })
        .catch(function (error) {
          loading.close();
          console.log(error); // 处理错误情况
        });
    },
    generateLogFileStr() {
      let s = "";
      this.multipleSelection.forEach(row => {
        s = s.concat(row.name, ",");
      });
      if (s.length > 0) {
        s = s.substring(0, s.length - 1);
      } else {
        s = 'null'
      }
      return s;
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    clearLogs() {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });

      let url = this.baseUrl3 + 'log/delete'
      // + this.deviceId + '/'+ encodeURIComponent(encodeURIComponent(this.logPath))
      let data = {
        instanceId:this.instanceId,
        path:this.logPath
      }

      this.$axios
        .post(url,data)
        .then(({ data: { msg, data, code } }) => {
          if (code == 20000) {
            this.$message.success('操作成功')
            this.selectLog('log')
          } else {
            this.$message({ showClose: true, message: msg, type: "error" });
            console.log(msg);
          }
          loading.close();
        })
        .catch(err => {
          loading.close();
          console.log(err);
        });
    }
  }
};
</script>
<style scoped>
.line {
  border-top: 1px solid #a0cfff;
}
</style>
